import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const PlusThin = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H15V27C15 27.5523 15.4477 28 16 28C16.5523 28 17 27.5523 17 27V17H27C27.5523 17 28 16.5523 28 16C28 15.4477 27.5523 15 27 15H17V5Z" />
	</svg>
);

export default PlusThin;
